import React, {Component} from 'react';
import {connect} from 'react-redux';
import ApplicationsAndPolicies from "../components/applicationsAndPolicies";
import {
    changeApplicationsAndPoliciesField, clearApplicationsAndPoliciesFilters, receiveGetAllApplications,
    requestGetAllApplications, requestGetAllApplicationsSuggestions 
} from "../actions/applicationsAndPolicies";
import { push } from 'connected-react-router'
import {requestBreachCausationCp} from "../actions/breachCausationCp";
import {isAragUser, isEntitySelected, isSolicitorUser} from "../helpers/functions";
import {getCaseTypes} from "../actions/caseTypes";
import {getSolicitorGroupCaseTypes} from "../actions/groups";
import {requestLawsysFirmsWithAgents} from "../actions/lawsysFirms";
import {requestGetApplicationStatuses} from "../actions/applicationStatuses";
import {getSolicitorUserColleagues, requestGetSolicitors} from "../actions/agentsList";

class ApplicationsAndPoliciesHOC extends Component {
	constructor(props){
		super(props);
	}
	// Teach Autosuggest how to calculate suggestions for any given input value.
	getSuggestions = value => {
		return this.props.applicationsAndPolicies.suggestions

	};

	getSuggestionValue = suggestion => suggestion !== undefined ?suggestion.clientName: null;

	renderSuggestion = suggestion => (
		<div>
			{suggestion.solicitorReference? suggestion.solicitorReference + ' | ': ''}{suggestion.aragReference ?suggestion.aragReference + ' | ':'' }{suggestion.clientName}
		</div>
	);

	onChange = (event, {newValue}) => {
		if (typeof newValue !== 'undefined') {
			if (newValue === '') {
				// this.props.changeApplicationsAndPoliciesField('suggestions', this.props.applicationsAndPolicies.applications);
			}
			this.props.changeApplicationsAndPoliciesField('value',newValue? newValue.toString(): '');
		}
	};

	onSuggestionsFetchRequested = ({value, reason}) => {
		this.props.changeApplicationsAndPoliciesField('suggestions',this.getSuggestions(value));
		};

	onSuggestionsClearRequested = () => {
		if (this.props.applicationsAndPolicies.value === '') {
			this.props.changeApplicationsAndPoliciesField('suggestions', []);
		}
	};

	onAppSuggestionSelected = (event, {suggestion, suggestionValue, suggestionIndex, sectionIndex, method}) => {
		if ( (method === 'enter' || method === 'click') && suggestion ){
			let newValue = '';
			if(suggestion.aragReference !=='' && suggestion.aragReference!==0){
				newValue = suggestion.aragReference;
			}else if(suggestion.clientName !==''){
				newValue = suggestion.clientName;
			}else if(suggestion.solicitorFileReference!==''){
				newValue = suggestion.solicitorFileReference;
			}
			let payload = {
				data: [suggestion],
				limit:0,
				offset:0,
				totalRecords: 1
			};
			this.props.receiveGetAllApplications(payload);
			this.props.changeApplicationsAndPoliciesField('value', newValue? newValue.toString(): '' );
			this.props.changeApplicationsAndPoliciesField('applications', [suggestion]);
		}
	};

	_getParameters = (props, searchParameter) => {
		const calcOffset = props.applicationsAndPolicies.selectedView * (props.applicationsAndPolicies.page - 1);
		const selectedCaseTypes = props.applicationsAndPolicies.selectedCaseTypes;
		var selectedSubCaseTypes = props.applicationsAndPolicies.selectedSubCaseTypes;
		const noCaseTypeSelected = selectedCaseTypes.length === 0;
		const selectedStatuses = props.applicationsAndPolicies.selectedStatuses;
		const noStatusesSelected = selectedStatuses.length === 0;
		const allSubCaseTypes =  this.props.caseTypes.subCases;
		//check for draft status
		if (props.applicationsAndPolicies.includeDraft &&
			props.user.loggedInUser.roles[0] !== 'Solicitor') {
			var draftStatus = props.applicationStatuses.filter(x => x.machineName == "Draft");
			var exists = selectedStatuses.filter(x => x.machineName == "Draft");
			if (exists.length == 0)
				selectedStatuses.push(draftStatus[0]);
		}
		else if (!props.applicationsAndPolicies.includeDraft &&
			props.user.loggedInUser.roles[0] !== 'Solicitor' && selectedStatuses.length > 0) {
			var exists = selectedStatuses.filter(x => x.machineName == "Draft");
			if (exists.length > 0) {
				selectedStatuses.splice(selectedStatuses.indexOf(exists), 1);
			}
		}

        return {
            limit: props.applicationsAndPolicies.selectedView,
            offset: calcOffset>0? calcOffset:0,
            shallow: true,
			selectedStatuses:selectedStatuses,
            search: searchParameter,
            selectedCaseTypes:selectedCaseTypes,
            selectedSubCaseTypes:selectedSubCaseTypes,
			lawsysId: props.applicationsAndPolicies.selectedSolicitorFirm?props.applicationsAndPolicies.selectedSolicitorFirm:null,
            selectedLawsys: props.applicationsAndPolicies.selectedSolicitorFirms,
            selectedSolicitorUsers: props.applicationsAndPolicies.selectedSolicitorUsers,

        };
	};

	handleAutosuggestButton = (suggestion) => {
		let parameters = this._getParameters(this.props, this.props.applicationsAndPolicies.value);
		this.props.getAllApplications(parameters);
	};

	handleAutosuggestValue = (suggestion) => {
		let parameters = this._getParameters(this.props,
            (suggestion.aragReference !== ''&& suggestion.aragReference!== 0)?suggestion.aragReference :
				(suggestion.solicitorReference!== '' )? suggestion.solicitorReference :
					(suggestion.clientName!==''?suggestion.clientName:this.props.applicationsAndPolicies.value));
		this.props.getAllApplications(parameters);
	};


	handleRowSelect = (application) => {
		this.props.changeApplicationsAndPoliciesField('selectedApplication', application);
		this.props.push('/application-and-policies/application-policy/' + application.id)
	};

	handlePageChange = (page) => {
		this.props.changeApplicationsAndPoliciesField('page', page);
	  };

	  handlePageSizeChange = (evt) => {
        this.props.changeApplicationsAndPoliciesField('selectedView', parseInt(evt.target.value));
    };

    handleGoAtPrevious = () => {
        if (this.props.applicationsAndPolicies.page > 1) {
            this.handlePageChange(this.props.applicationsAndPolicies.page - 1);
        }
    };

    handleGoAtNext = () => {
        if (this.props.applicationsAndPolicies.page < this.props.applicationsAndPolicies.totalBoxes) {
            this.handlePageChange(this.props.applicationsAndPolicies.page + 1);
        }
    };

    handleGoAtStart = () => {
        this.handlePageChange(1);
    };

    handleGoAtEnd = () => {
        this.handlePageChange(this.props.applicationsAndPolicies.totalBoxes);
    };

    handleGoAtPage = (page) => {
        this.handlePageChange(page);
    };	  

	componentWillMount() {
		let parameters = this._getParameters(this.props,
			this.props.applicationsAndPolicies.value === '' ? null : this.props.applicationsAndPolicies.value,
		);
        this.props.getAllApplications(parameters);
        this.props.requestGetApplicationStatuses();
        if(isAragUser(this.props.user.loggedInUser.roles)){
            this.props.requestGetCaseTypes();
            this.props.requestLawsysFirmsWithAgents();
            this.props.requestGetSolicitors({
				limit: 0,
				offset: 0,
				lawsysId: null,
				search: null,
                orderAsc: true,
                orderBySolicitorName: true
            });
        }

        if(isSolicitorUser(this.props.user.loggedInUser.roles) && this.props.user.loggedInUser.solicitorGroupId){
            this.props.getSolicitorGroupCaseTypes(this.props.user.loggedInUser.solicitorGroupId);
        }

        if(
        	isSolicitorUser(this.props.user.loggedInUser.roles)
			&& this.props.user.loggedInUser.allowedToSeeAllFirmApplications
		) {
        	this.props.getSolicitorUserColleagues();
		}

	}

	componentWillReceiveProps(nextProps) {

		if(
			this.props.applicationsAndPolicies.selectedView !== nextProps.applicationsAndPolicies.selectedView ||
			this.props.applicationsAndPolicies.value !== nextProps.applicationsAndPolicies.value ||
			this.props.applicationsAndPolicies.page !== nextProps.applicationsAndPolicies.page ||
			(this.props.applicationsAndPolicies.wasFilterButtonPressed && !nextProps.applicationsAndPolicies.wasFilterButtonPressed)
		) {
			let parameters = this._getParameters(nextProps,
                nextProps.applicationsAndPolicies.value === '' ? null : nextProps.applicationsAndPolicies.value
            );
			clearTimeout(this.askServer);
			if(this.props.applicationsAndPolicies.value!==nextProps.applicationsAndPolicies.value && nextProps.applicationsAndPolicies.value!=='' ){
				parameters.offset = 0;
				parameters.limit = 5;
                this.askServer = setTimeout(()=>{this.props.getAllApplicationsSuggestions(parameters)},250);
			}else {
				this.props.getAllApplications(parameters);
			}
		}

		if ((isSolicitorUser(this.props.user.loggedInUser.roles) ? this.props.solicitorCaseTypes.length > 0 : this.props.caseTypes.cases.length > 0) &&
			this.props.applicationsAndPolicies.availableCaseTypes.length == 0 &&
			this.props.applicationsAndPolicies.selectedCaseTypes.length == 0) 
		{
			this._getCaseTypesOptions();
		}
		if ((isSolicitorUser(this.props.user.loggedInUser.roles) ? this.props.solicitorCaseTypes.length > 0 : this.props.caseTypes.cases.length > 0)
			&& (isSolicitorUser(this.props.user.loggedInUser.roles) ? this.props.solicitorSubCaseTypes.length > 0 : this.props.caseTypes.subCases.length > 0)
			&& (this.props.applicationsAndPolicies.availableSubCaseTypes.length == 0)
			&& this.props.applicationsAndPolicies.selectedSubCaseTypes.length == 0 && this.props.applicationsAndPolicies.selectedCaseTypes.length == 0) 
		{
			this._getSubCaseTypesOptions([]);
		}

		if((this.props.applicationsAndPolicies.selectedSubCaseTypes.length != nextProps.applicationsAndPolicies.selectedSubCaseTypes.length) ||
		(this.props.applicationsAndPolicies.selectedCaseTypes.length != nextProps.applicationsAndPolicies.selectedCaseTypes.length))
		{
			this._getSubCaseTypesOptions(nextProps.applicationsAndPolicies.selectedCaseTypes);
		}
	}

    _getCaseTypesOptions = () => {
		var caseTypeOptions = [];
        if(isAragUser(this.props.user.loggedInUser.roles)){
            caseTypeOptions = this.props.caseTypes.cases.map(item => {
               return {value: item.id, label: item.name, machineName: item.machineName}
           });
        }

        if(isSolicitorUser(this.props.user.loggedInUser.roles)){
            caseTypeOptions = this.props.solicitorCaseTypes.map(item => (
			{value: item.id, label: item.name, machineName: item.machineName})
           )
        }

		this.props.changeApplicationsAndPoliciesField('availableCaseTypes',caseTypeOptions);

    };

	_getSubCaseTypesOptions = (caseTypes) => {

		var subCases = this.props.caseTypes.subCases;
		if (isSolicitorUser(this.props.user.loggedInUser.roles)) {
			subCases = this.props.solicitorSubCaseTypes;
		}
		if (caseTypes.length > 0)
		{//filter sub case types options for selected case types
			const caseTypesIds = caseTypes.map(c => c.value);
			subCases = subCases.filter(c => caseTypesIds.includes(c.caseTypeId));
		}
		var toUpdate = subCases.map(item => (
			{value: item.id, label: item.name, machineName: item.machineName}))

		this.props.changeApplicationsAndPoliciesField('availableSubCaseTypes', toUpdate);

	};
    handleSolicitorFirmsFilterChange = (values) => {
		this.props.changeApplicationsAndPoliciesField('selectedSolicitorFirms', values);
	};

    handleSolicitorUsersFirmsFilterChange = (values) => {
    	this.props.changeApplicationsAndPoliciesField('selectedSolicitorUsers', values);
	};

	handleStatusesFilterChange = (values) => {
		this.props.changeApplicationsAndPoliciesField('selectedStatuses', values);
	};

	handleCaseTypesFilterChange = (values) => {
		this.props.changeApplicationsAndPoliciesField('selectedCaseTypes', values);
	};
	handleSubCaseTypesFilterChange = (values) => {
		this.props.changeApplicationsAndPoliciesField('selectedSubCaseTypes', values);
	};
    getSolicitorUsersForMultipleSelect = () => {
		return this.props.solicitorUsers
			.filter(user => {
				return (
					this.props.applicationsAndPolicies.selectedSolicitorFirms.find(firm => firm.value === user.lawsysId)
					|| this.props.applicationsAndPolicies.selectedSolicitorFirms.length === 0
				)
			})
			.map(user => ({value: user.userId, label: `${user.forename} ${user.surname}`}))
	};

    handleFilterClick = () => {
		this.props.changeApplicationsAndPoliciesField('wasFilterButtonPressed', true);
		let parameters = this._getParameters(this.props,
            this.props.applicationsAndPolicies.value === '' ? null : this.props.applicationsAndPolicies.value
        );
        this.props.getAllApplications(parameters);
    };

	render() {
		let value = this.props.applicationsAndPolicies.value;
		const inputProps = {
			placeholder: '',
			value,
			onChange: this.onChange
		};
		return (
			<ApplicationsAndPolicies
				applicationStatuses={this.props.applicationStatuses}
                clearApplicationsAndPoliciesFilters={this.props.clearApplicationsAndPoliciesFilters}
                handleFilterClick={this.handleFilterClick}
				handleCaseTypesFilterChange={this.handleCaseTypesFilterChange}
				handleSubCaseTypesFilterChange={this.handleSubCaseTypesFilterChange}
				handleStatusesFilterChange={this.handleStatusesFilterChange}
                handleSolicitorFirmsFilterChange={this.handleSolicitorFirmsFilterChange}
				caseTypesOptions={this.props.applicationsAndPolicies.availableCaseTypes}
				isAgentAllowedToSeeAllFirmApplications={this.props.user.loggedInUser.allowedToSeeAllFirmApplications}
				userRoles={this.props.user.loggedInUser.roles}
				Store={this.props.applicationsAndPolicies}
				UserRole={this.props.user.loggedInUser.roles[0]}
				HandleRowSelect={this.handleRowSelect}
				HandleAutosuggestButton={this.handleAutosuggestButton}
				HandleAutosuggestValue={this.handleAutosuggestValue}
				onSuggestionSelected={this.onAppSuggestionSelected}
				suggestions={this.props.applicationsAndPolicies.suggestions}
				getSuggestionValue={this.getSuggestionValue}
				renderSuggestion={this.renderSuggestion}
				onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
				onSuggestionsClearRequested={this.onSuggestionsClearRequested}
				inputProps={inputProps}
				HandleInputChange={this.props.changeApplicationsAndPoliciesField}
				getApplications = {this.props.getAllApplications}
                lawsysFirms={this.props.lawsysFirms}
                solicitorUsers={this.props.solicitorUsers}
                handleSolicitorUsersFirmsFilterChange={this.handleSolicitorUsersFirmsFilterChange}
                fetchingSolicitorUsers={this.props.fetchingSolicitorUsers}
                fetchingLawsysFirms={this.props.fetchingLawsysFirms}
				getSolicitorUsersForMultipleSelect={this.getSolicitorUsersForMultipleSelect}
				subCaseTypesOptions={this.props.applicationsAndPolicies.availableSubCaseTypes}
                onPageSizeChange={this.handlePageSizeChange}
                goAtPrevious={this.handleGoAtPrevious}
                goAtNext={this.handleGoAtNext}
                goAtStart={this.handleGoAtStart}
                goAtEnd={this.handleGoAtEnd}
                goAtPage={this.handleGoAtPage}
			/>

		)
	}
}

const mapStateToProps = (state) => {
	return {
		applicationsAndPolicies: state.applicationsAndPolicies,
		user: state.user,
        caseTypes: state.caseTypes,
        solicitorCaseTypes: state.newApplication.caseTypes,
        solicitorSubCaseTypes: state.newApplication.subCaseTypes,
        lawsysFirms: state.lawsysFirms.lawsysFirms,
        solicitorUsers: state.agentsList.displayedUsers,
        fetchingSolicitorUsers: state.agentsList.fetching,
        fetchingLawsysFirms: state.lawsysFirms.fetching,
		applicationStatuses: state.applicationStatuses.statuses,
		applicationAcceptedStatusesTransitions: state.applicationAcceptedStatusesTransitions.transitions
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		getAllApplications: (payload) => {
			dispatch(requestGetAllApplications(payload))
		},
		receiveGetAllApplications: (payload) => {
			dispatch(receiveGetAllApplications(payload))
		},
		getAllApplicationsSuggestions: (payload) => {
			dispatch(requestGetAllApplicationsSuggestions(payload))
		},
		changeApplicationsAndPoliciesField: (key, value) => {
			dispatch(changeApplicationsAndPoliciesField(key, value))
		},
		push: (path) => {
			dispatch(push(path))
		},
		requestBreachCausationCp: () => {
			dispatch(requestBreachCausationCp());
		},
        requestGetCaseTypes: () => {
            dispatch(getCaseTypes())
        },
        getSolicitorGroupCaseTypes: (groupId) => {
            dispatch(getSolicitorGroupCaseTypes(groupId))
        },
        requestLawsysFirmsWithAgents: (payload) => {
			dispatch(requestLawsysFirmsWithAgents(payload))
		},
        requestGetSolicitors: (payload) => {
		    dispatch(requestGetSolicitors(payload))
        },
        clearApplicationsAndPoliciesFilters: (payload) => {
		    dispatch(clearApplicationsAndPoliciesFilters(payload))
        },
		getSolicitorUserColleagues: (payload) => {
			dispatch(getSolicitorUserColleagues(payload))

        },
		requestGetApplicationStatuses: () => {
			dispatch(requestGetApplicationStatuses())
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationsAndPoliciesHOC);
